import React, { useContext } from "react";
import { WebsiteContext } from "../context/AppContext";
import { FaCheckCircle, FaCarSide } from "react-icons/fa";

const PriceCard = ({
  carTitle,
  carSubTitle,
  ratePerKm,
  tripType1,
  tripType2,
  tripType3,
  tripType4,
  tripRate1,
  tripRate2,
  tripRate3,
  tripRate4,
  isPopular,
}) => {
  const { isMobileView } = useContext(WebsiteContext);

  return (
    <div
      className={`price_card_container ${isPopular ? "popular_card" : ""} ${isMobileView ? "mobile" : ""}`}
    >
      {isPopular && <div className="popular_badge">Most Selected</div>}

      <div className="price_card_header">
        <div className="car_icon_wrapper">
          <FaCarSide className="car_icon" />
        </div>
        <h3 className="carTitle">{carTitle}</h3>
        <p className="carSubTitle">{carSubTitle}</p>
        <div className="rate_badge">
          <span className="rate_value">{ratePerKm.split("/")[0]}</span>
          <span className="rate_suffix">/ {ratePerKm.split("/")[1]}</span>
        </div>
      </div>

      <div className="price_card_divider"></div>

      <div className="price_card_body">
        <h4 className="details_title">Trip Details</h4>
        <ul className="trip_details_list">
          <li className="trip_item">
            <div className="trip_type">
              <FaCheckCircle className="check_icon" />
              <span>{tripType1}</span>
            </div>
            <span className="trip_rate">{tripRate1}</span>
          </li>
          <li className="trip_item">
            <div className="trip_type">
              <FaCheckCircle className="check_icon" />
              <span>{tripType2}</span>
            </div>
            <span className="trip_rate">{tripRate2}</span>
          </li>
          <li className="trip_item">
            <div className="trip_type">
              <FaCheckCircle className="check_icon" />
              <span>{tripType3}</span>
            </div>
            <span className="trip_rate">{tripRate3}</span>
          </li>
          <li className="trip_item">
            <div className="trip_type">
              <FaCheckCircle className="check_icon" />
              <span>{tripType4}</span>
            </div>
            <span className="trip_rate">{tripRate4}</span>
          </li>
        </ul>
      </div>

      <div className="price_card_footer">
        <a href="#booking_section" className="book_now_btn">
          Book Now
        </a>
      </div>
    </div>
  );
};

export default PriceCard;
